<template>
    <div class="main">
        <div class="title">{{title}}</div>
        <div class="help_content">

            <div class="help_item" v-for="(item , index) in menuList" :key="index" v-show="item.visible">

                <router-link :to="item.authStatus ? item.authedHref : item.href" :data-status="item.authStatus"
                     data-note="认证类链接" v-if="item.type === '1'">
                    <img class="cover alignM fl marginR8" style="width:24px;height:24px;" :src="item.img" alt="">
                    <span class="font_position">
                        <template v-if="item.authStatus">
                            {{item.name}}主页
                        </template>
                        <template v-else>
                            <template v-if="item.name === '分销员'">分享赚钱</template>
                            <template v-else>我要成为{{item.name}}</template>
                        </template>

                    </span>
                    <div class="icon_position font13r grey777">
                        <img class="relative" style="width:16px;height:16px; top: 3px;" src="icon/userIcon/help_right.png" alt="">
                    </div>
                </router-link>

                <a href="javascript:;" data-note="普通链接" v-else="" @click="clickLink(item)">
                    <img class="cover alignM fl marginR8" style="width:24px;height:24px;" :src="item.img" alt="">
                    <span class="font_position">
                        {{ item.name }}
                    </span>
                    <div class="icon_position font13r grey777">
                        <img class="relative" style="width:16px;height:16px; top: 3px;" src="icon/userIcon/help_right.png" alt="">
                    </div>
                </a>

            </div>
        </div>

    </div>
</template>
<script>
// platform api and util
import consoleApi from '@/components/platformApi/consoleApi';
import distributorApi from "@comp/distributor/distributorApi";
import requestManager from "@comp/platformApi/requestManager";
import appHelper from "@util/appHelper";
import externalApp from "@data/externalApp";

export default {
    data(){
        return{
            // 其实就是原来的认证中心
            title : '权益中心',
            menuList:[
                // type: 1 代表VIP认证，显示方式有些特别
                {
                    img: 'icon/userIcon/poster_icon.png',
                    name:'园所',
                    href: '/',
                    authedHref : '/',
                    type : '1',
                    visible : false,
                    authStatus : false
                },
                {
                    img: 'icon/userIcon/poster_icon.png',
                    name:'主办方',
                    href: '/auth/sponsorAuth',
                    authedHref : '/underlineCourse/sponsor/personalCenter',
                    type : '1',
                    visible : false,
                    authStatus : false
                },
                {
                    img: 'icon/userIcon/poster_icon.png',
                    name:'合作老师',
                    href: '/auth/teacherAuth',
                    authedHref : '/teacher/personalCenter',
                    type : '1',
                    visible : false,
                    authStatus : false
                },
                {
                    img: 'icon/userIcon/poster_icon.png',
                    name:'代理商',
                    href : '/auth/agencyAuth',
                    authedHref : '/agency/personalCenter',
                    type : '1',
                    visible : false,
                    authStatus : false
                },
                {
                    img: 'icon/userIcon/poster_icon.png',
                    name:'分销员',
                    href : '/auth/distributorAuth',
                    authedHref : '/distributor/personalCenter',
                    type : '1',
                    visible : true,
                    authStatus : false
                },{
                    img: 'icon/userIcon/poster_icon.png',
                    name:'分销员',
                    href : '/auth/distributorAuth',
                    type : '1',
                    visible : false,
                    authStatus : false
                },
                // {
                //     img: 'icon/userIcon/poster_icon.png',
                //     name:'手动激活会员',
                //     href : externalApp.oldShixun.baseUrl + 'html/me/openVip.html',
                //     authedHref : '/distributor/personalCenter',
                //     type : '',
                //     visible : true,
                //     authStatus : true
                // },
                {
                    img: 'icon/userIcon/shixun_vip_icon.png',
                    name:'师讯会员',
                    href : '/vip',
                    authedHref : '/vip',
                    type : '',
                    visible : true,
                },


            ],

            distributorInfo : null
        }
    },
    methods : {
        clickLink(item) {
            appHelper.redirect(item.href);
        }
    },
    mounted() {

        const me = this;

        distributorApi.loadSalemanInfo((result) => {
            me.distributorInfo = result.data;

            requestManager.request({
                url : 'portal/v4/user/center/getAuthenticationStatus'
            }, (error, result) => {
                if (error) { return; }
                if (result.errorCode) {
                    appHelper.showHint(result.msg);
                    return;
                }

                me.menuList[0].authStatus   = result.data.isKindergarten;
                me.menuList[1].authStatus   = result.data.isUnderlineSponsor;
                me.menuList[2].authStatus   = result.data.isTeacher;
                me.menuList[3].authStatus   = result.data.isAgency;
                me.menuList[3].visible      = me.menuList[3].authStatus;
                me.menuList[4].authStatus   = result.data.isSalesman;
                // 不是分销员或者不是高级的那种
                me.menuList[5].visible      = !result.data.isSalesman || (me.distributorInfo.roleId != 1);

                me.$forceUpdate();
            });
        });


    }
}
</script>
<style lang="scss" scoped>
.grey777 {
    color: #777;
}
.main{
    //width:90%;
    margin:0 auto;
    background:#fff;
    margin-top: 16px;
    border-radius: 8px;
    padding: 0 16px;
    box-sizing: border-box;
}

.title{
    padding-top: 12px;
    font-size: 18px;

    font-weight: 600;
    color: #000;

}

.help_content{
    width: 100%;
    padding-bottom: 2px;
    .help_item{
        margin: 16px 0;
        width:100%;
        height: 24px;
        line-height: 24px;
        position: relative;
        .font_position{
            font-size: 14px;

            font-weight: 400;
            color: #333333;

        }
        .icon_position{
            position: absolute;
            top: 4px;
            right: 0px;
        }
    }
}


</style>
